<template>
  <div>
    <el-drawer :wrapperClosable="false" :visible.sync="ruleDialogVisble" size="680px" destroy-on-close :show-close="false">
      <template #title>
        <div style="height: 50px">
          <drawer-header :title="ruleDialogTitle" :is-add="true" :subLoading="submitLoading" @close="handleClose"
            @confirm="handleSubmit" />
        </div>
      </template>
      <div style="padding:0 20px;">
        <el-form :model="deviceRuleForm" :rules="deviceRule" ref="deviceRuleRef">
          <el-row>
            <el-col>
              <el-form-item label="规则名称" prop="name">
                <el-input v-model="deviceRuleForm.name" />
              </el-form-item>
            </el-col>
  <!--					<el-col>
              <el-form-item label="规则编号" prop="ruleNumber">
                <el-input-number :min="1" :precision="0" v-model="deviceRuleForm.ruleNumber"
                  :disabled="deviceRuleForm.id" />
              </el-form-item>
            </el-col>-->
            <el-col>
              <el-form-item label="是否启用">
                <el-switch v-model="deviceRuleForm.status" :active-value="1" :inactive-value="0" />
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="备注">
                <el-input type="textarea" rows="2" v-model="deviceRuleForm.remark" />
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item>
                <el-radio-group v-model="deviceRuleForm.type" size="medium" @change="changeRuleType">
                  <el-radio-button :label="1">按周</el-radio-button>
                  <el-radio-button :label="2">按时段</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <!-- <el-col>
              <el-button type="primary" @click="handleAddTimeRule" style="margin-bottom: 10px;"
                v-if="deviceRuleForm.type === 2">添加规则</el-button>
            </el-col> -->
          </el-row>

          <el-row :gutter="24" class="mt-4">
            <el-col :span="24" v-if="deviceRuleForm.type === 1" style="margin-bottom: 10px;">
              <el-tabs v-model="activeName" :stretch="true">
                <el-tab-pane v-for="(item, index) in deviceRuleForm.weekRules" :key="index" :label="formatterDay(index)" :name="index">
                  <el-card shadow="never">
                    <template #header>
                      <el-row>
                        <el-col :span="12">
                          <div class="card-header">
                            <span>{{ formatterDay(index) }}</span>
                            <el-tooltip class="item" effect="dark" content="复制到" placement="top">
                              <i class="el-icon-document-copy" @click="copeRule(index)" style="margin-left: 10px;cursor: pointer"></i>
                            </el-tooltip>
                          </div>
                        </el-col>
                        <el-col :span="12">
                          <div style="text-align: right;">
                            全天
                            <el-switch v-model="item.isFullDay"
                                       @change="(val) =>hanldeWeekFullDay(val,item)" />
                          </div>
                        </el-col>
                      </el-row>
                    </template>
                    <div style="overflow-y: auto; height: 130px;">
                      <el-form-item label="规则时段" style="margin-bottom: 0px ; white-space: nowrap;"
                                    v-for="(rule, ruleIndex) in item.intervals" :key="'device_rule_time_form_item_'+ruleIndex">
                        <el-time-picker style="width:calc(100% - 190px)"
                                        is-range
                                        size="small"
                                        :key="'device_time-picker_'+index+'_'+ruleIndex"
                                        :disabled="item.isFullDay"
                                        v-model="rule.periods"
                                        format="HH:mm"
                                        value-format="HH:mm"
                                        @click.stop
                                        @change.stop
                                        @blur.stop
                                        @focus.stop
                                        start-placeholder="开始时间"
                                        range-separator="~"
                                        end-placeholder="结束时间"
                                        :destroy-on-close="true">
                          <!-- @blur="(arr) => changeWeekTime(arr,item,index)" -->
                        </el-time-picker>
                        <el-select style="margin-left: 5px; width:80px" size="small"
                                   v-model="rule.type">
                          <el-option v-for="(deviceType,index) in deviceTypeList" :key="index"
                                     :value="deviceType.id" :label="deviceType.name"></el-option>
                        </el-select>
                        <el-link type="primary" style="margin-left: 5px; margin-bottom: 5px;"
                                 v-if="item.intervals.length !== 6 && ruleIndex == 0  && !item.isFullDay"
                                 @click="hanldeAddRule(item)">添加</el-link>
                        <el-link type="danger" style="margin-left: 5px;margin-bottom: 5px;"
                                 v-if="item.intervals.length !== 1 && ruleIndex !== 0"
                                 @click="hanldeDeleteRule(item,ruleIndex)">删除</el-link>
                      </el-form-item>
                    </div>
                  </el-card>
                </el-tab-pane>
              </el-tabs>
            </el-col>
            <!-- 按时段显示规则 -->
            <el-col :span="24" v-if="deviceRuleForm.type === 2"
                    v-for="(item, index) in deviceRuleForm.timeRules" :key="index" style="margin-bottom: 10px;">
              <el-card shadow="never">
                <template #header>
                  <div style="display: flex;justify-content: space-between;align-items: center">
                    <el-date-picker v-model="item.rulesDate" style="width:calc(100% - 120px)" size="small"
                                    type="daterange" value-format="yyyy-MM-dd" range-separator="~"
                                    start-placeholder="开始日期" end-placeholder="结束日期">
                    </el-date-picker>
                    <div>
                      全天<el-switch v-model="item.rule.isFullDay"
                                     @change="(val) =>hanldeTimeFullDay(val,item)" />
                    </div>
                    <!-- <el-link type="danger" @click="handleDeleteTimeRule(index)"
                      style="margin-left: 20px;">删除</el-link> -->
                  </div>
                </template>
                <div style="overflow-y: auto; height: 130px;">
                  <el-form-item label="规则时段" style="margin-bottom: 0px ; white-space: nowrap;"
                                v-for="(rule, ruleIndex) in item.rule.intervals"
                                :key="'device_rule_time_form_item_2_'+ruleIndex">
                    <div style="width: 100%;" :key="'device_time-picker2_2_'+index+'_'+ruleIndex">
                      <el-time-picker style="width:calc(100% - 190px)"
                                      is-range
                                      size="small"
                                      :key="'device_time-picker_2_'+index+'_'+ruleIndex"
                                      :disabled="item.rule.isFullDay"
                                      v-model="rule.periods"
                                      format="HH:mm"
                                      value-format="HH:mm"
                                      @click.stop
                                      @change.stop
                                      @blur.stop
                                      @focus.stop
                                      start-placeholder="开始时间"
                                      range-separator="~"
                                      end-placeholder="结束时间"
                                      :destroy-on-close="true">
                        <!-- @blur="(arr) => changeTime(arr,item,index)" -->
                      </el-time-picker>
                      <el-select style="margin-left: 5px; width:80px" size="small"
                                 v-model="rule.type">
                        <el-option v-for="(deviceType,index) in deviceTypeList" :key="index"
                                   :value="deviceType.id" :label="deviceType.name"></el-option>
                      </el-select>
                      <el-link type="primary" style="margin-left: 5px; margin-bottom: 5px;"
                               v-if="item.rule.intervals.length !== 6 && ruleIndex == 0 && !item.rule.isFullDay"
                               @click="handleAddTime(item.rule.intervals)">添加</el-link>
                      <el-link type="danger" style="margin-left: 5px;margin-bottom: 5px;"
                               v-if="item.rule.intervals.length !== 1 && ruleIndex !== 0"
                               @click="handledelTime(item.rule.intervals,ruleIndex)">删除</el-link>
                    </div>
                  </el-form-item>
                </div>
              </el-card>
            </el-col>
            <el-col :span="24">
              <el-card shadow="never" >
                <el-transfer class="device-binding-transfer" :titles="titles" filterable filter-placeholder="请输入设备名称"
                             v-model="deviceList" :data="deviceData">

                  <div slot-scope="{ option }" :class="option.disabled ? 'offline' : 'online'">
                    <el-tooltip class="item" effect="dark" :content="option.name +'（'+ option.sn +'）'" placement="top-start">
                      <div class="option_label">
                        <span style="font-size: 14px; font-weight: 400;">{{ option.name }}</span>
                        <span style="color: #b2b2b2;margin-left: 5px;">({{ option.sn }})</span>
                      </div>
                    </el-tooltip>

                  </div>
                </el-transfer>
              </el-card>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-drawer>
    <el-dialog title="复制规则" :visible.sync="copeDialogVisible"  width="30%">
      <div style="padding: 20px 30px;">
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        <div style="margin: 15px 0;"></div>
        <el-checkbox-group style=" display: grid;grid-template-columns: repeat(4, 1fr); grid-auto-rows: minmax(20px, auto);gap: 10px;" v-model="checkedWeeks" @change="handleCheckedWeeksChange">
          <el-checkbox v-for="week in weeks" :label="week.value" :key="week.value">{{week.label}}</el-checkbox>
        </el-checkbox-group>
      </div>
      <div style="text-align: center;">
        <el-button @click="copeDialogVisible=false">取 消</el-button>
        <el-button type="primary" @click="submitCopeRule">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
	import DrawerHeader from "@/components/drawerHeader.vue"
	import {
		DeviceRuleApi
	} from "@/api/nexus/deviceRule"
	import {
		validRuleTime,
		hasDateRangeOverlap
	} from "@/views/nexus/validRule"
	export default {
		components: {
			DrawerHeader
		},
		data() {
			return {
				//抽屉信息
				ruleDialogTitle: '',
				ruleDialogVisble: false,
				//设备门禁规则
				deviceRuleForm: {},
				//提交loading
				submitLoading: false,
        activeName: 'sun',
				deviceRule: {
					name: {
						required: true,
						message: '请输入规则名称',
						trigger: 'blur'
					},
				},
				//门禁开门类型
				deviceTypeList: [{
						id: 10,
						name: '默认'
					},
					{
						id: 20,
						name: '常开'
					},
					{
						id: 30,
						name: '常闭'
					},
				],
        titles: ["未绑定设备", "已绑定设备"],
        //未设备集合
        deviceData: [],
        //已绑定设备集合
        deviceList: [],copeDialogVisible: false,
        copeRuleDay: '',
        checkAll: false,
        checkedWeeks: [],
        weeks: [
          {value:'sun', label: '星期天'},
          {value:'mon', label: '星期一'},
          {value:'tue', label: '星期二'},
          {value:'wed', label: '星期三'},
          {value:'thu', label: '星期四'},
          {value:'fri', label: '星期五'},
          {value:'sat', label: '星期六'}
        ],
        isIndeterminate: false

			}
		},
		methods: {
			//数据提交
			handleSubmit() {
				this.$refs.deviceRuleRef.validate(async valid => {
					this.submitLoading = true;
					//验证所有规则
					if (valid && this.validFormRule()) {
						// console.log("最后提交数据",this.deviceRuleForm)
            this.deviceRuleForm.deviceList = this.deviceList;
						let {
							code,
							message
						} = await DeviceRuleApi.save(this.deviceRuleForm);
						if (code == 200) {
							this.$message.success("保存成功")
							this.ruleDialogVisble = false;
							this.$emit("on-load")
						} else {
							this.$message.error(message)
						}
					}
					this.submitLoading = false;
				})
			},
			//验证规则
			validFormRule() {
				let type = this.deviceRuleForm.type;
				//按周验证
				if (type === 1) {
					// let rulesArr = Object.values(this.deviceRuleForm.weekRules);
					// //验证每个星期的规则
					// for (const [index, obj] of rulesArr.entries()) {
					// 	let bool = validRuleTime(obj.intervals.map(item => {
					// 		return item.periods
					// 	}));
					// 	if (!bool) {
					// 		let day = this.formatterDay(Object.keys(this.deviceRuleForm.weekRules)[index]);
					// 		this.$message.error(day.concat("的规则时段配置错误，开始时间必须大于上一段的结束时间"));
					// 		return false;
					// 	}
					// }
					return true;
				} else {
					//按时段验证
					for (const [index, deviceRule] of this.deviceRuleForm.timeRules.entries()) {
						if (deviceRule.rulesDate.length == 0) {
							this.$message.error("规则日期不能为空");
							return false;
						}
						if (hasDateRangeOverlap(this.deviceRuleForm.timeRules, deviceRule.rulesDate, index)) {
							this.$message.error(`第 ${index + 1} 条规则日期与其他规则重叠`);
							return false;
						}
						//验证每个日期的时段
						// if (!validRuleTime(deviceRule.rule.intervals.map(item => {
						// 		return item.periods
						// 	}))) {
						// 	this.$message.error(deviceRule.rulesDate[0].concat("~", deviceRule.rulesDate[1],
						// 		"的规则时段配置错误，开始时间必须大于上一段的结束时间"))
						// 	return false;
						// }
						this.$set(deviceRule, "startDate", deviceRule.rulesDate[0]);
						this.$set(deviceRule, "endDate", deviceRule.rulesDate[1]);
					}
					return true;
				}
			},
			async show(id) {
				this.ruleDialogTitle = id ? "修改设备门禁规则" : "新增设备门禁规则"
				if (id) {
					let { code, data } = await DeviceRuleApi.getById(id);
					if (code == 200) {
						if (data.type === 2) {
							data.timeRules.forEach(timeRule => {
								timeRule.rulesDate = [timeRule.startDate, timeRule.endDate]
							})
						}
						this.deviceRuleForm = Object.assign({}, data)
					}
          this.deviceData = [];
          this.deviceList = [];
          this.getNotBindDeviceList(id);
          this.getBindDeviceList(id);
				} else {
					let { code, data } = await DeviceRuleApi.getRuleNumber();
					if (code == 200) {
						this.initDeviceRuleForm(data);
					}
          this.deviceData = [];
          this.deviceList = [];
          this.getNotBindDeviceList(null);
          // this.getBindDeviceList(ruleId);
				}
				this.ruleDialogVisble = true;
        this.$nextTick(() => {
          this.$forceUpdate();
        })
			},
			handleClose() {
				this.ruleDialogVisble = false;
			},
			//添加时段规则
			handleAddTimeRule() {
				let rules = {
					rulesDate: [],
					rule: {
						isFullDay: false,
						intervals: [{
							periods: ["00:00", "23:59"],
							type: 10
						}]
					}
				}
				this.deviceRuleForm.timeRules.push(rules);
			},
			//按时段设置全天
			hanldeTimeFullDay(val, obj) {
				if (val) {
					obj.rule.intervals.splice(0);
					obj.rule.intervals.push({
						periods: ["00:00", "23:59"],
						type: 10
					});
				}
			},
			//按时段删除
			handleDeleteTimeRule(index) {
				this.deviceRuleForm.timeRules.splice(index, 1)
			},
			//按时段添加规则
			handleAddTime(times) {
				times.push({
					periods: ["00:00", "23:59"],
					type: 10
				})
			},
			//移除时段
			handledelTime(times, index) {
				times.splice(index, 1)
			},
			//按时段验证当前操作的区间时段
			// changeTime(val, obj, index) {
			// 	let bool = validRuleTime(obj.rule.intervals.map(item => {
			// 		return item.periods
			// 	}));
			// 	if (!bool && obj.rulesDate.length > 0) {
			// 		this.$message.error(obj.rulesDate[0].concat("~", obj.rulesDate[1], "的规则时段配置错误，开始时间必须大于上一段的结束时间"))
			// 	}
			// },
			//规则显示星期格式化
			formatterDay(index) {
				switch (index) {
					case "mon":
						return "星期一";
					case "tue":
						return "星期二";
					case "wed":
						return "星期三";
					case "thu":
						return "星期四";
					case "fri":
						return "星期五";
					case "sat":
						return "星期六";
					case "sun":
						return "星期天";
				}
			},
			//按周设置全天
			hanldeWeekFullDay(val, obj) {
				if (val) {
					obj.intervals.splice(0);
					obj.intervals.push({
						periods: ["00:00", "23:59"],
						type: 10
					});
				}
			},
			//验证当前操作的星期时段
			// changeWeekTime(val, obj, index) {
			// 	let bool = validRuleTime(obj.intervals.map(item => {
			// 		return item.periods
			// 	}));
			// 	if (!bool) {
			// 		let day = this.formatterDay(index);
			// 		this.$message.error(day.concat("的规则时段配置错误，开始时间必须大于上一段的结束时间"))
			// 	}
			// },
			//按周添加时段
			hanldeAddRule(obj) {
				obj.intervals.push({
					periods: ["00:00", "23:59"],
					type: 10
				});

			},
			//按周删除规则时段
			hanldeDeleteRule(obj, index) {
				obj.intervals.splice(index, 1)
			},
			//按周按时段切换
			changeRuleType(val) {
				val === 1 ? this.initWeekRules() : this.initTimeRules();
			},
			//初始化按时段规则
			initTimeRules() {
				let timeRules = [{
					rulesDate: [],
					rule: {
						isFullDay: false,
						intervals: [{
							periods: [
								"00:00",
								"23:59"
							],
							type: 10
						}]
					}
				}];
				this.$nextTick(() => {
					this.$set(this.deviceRuleForm, "timeRules", timeRules);
					this.$delete(this.deviceRuleForm, 'weekRules');
				})
			},
			//初始化按周规则
			initWeekRules() {
				let weekRules = {
					sun: {
						isFullDay: false,
						intervals: [{
							periods: [
								"00:00",
								"23:59"
							],
							type: 10
						}]
					},
					mon: {
						isFullDay: false,
						intervals: [{
							periods: [
								"00:00",
								"23:59"
							],
							type: 10
						}]
					},
					tue: {
						isFullDay: false,
						intervals: [{
							periods: [
								"00:00",
								"23:59"
							],
							type: 10
						}]
					},
					wed: {
						isFullDay: false,
						intervals: [{
							periods: [
								"00:00",
								"23:59"
							],
							type: 10
						}]
					},
					thu: {
						isFullDay: false,
						intervals: [{
							periods: [
								"00:00",
								"23:59"
							],
							type: 10
						}]
					},
					fri: {
						isFullDay: false,
						intervals: [{
							periods: [
								"00:00",
								"23:59"
							],
							type: 10
						}]
					},
					sat: {
						isFullDay: false,
						intervals: [{
							periods: [
								"00:00",
								"23:59"
							],
							type: 10
						}]
					}
				};
				this.$nextTick(() => {
					this.$set(this.deviceRuleForm, "weekRules", weekRules);
					this.$delete(this.deviceRuleForm, "timeRules");
				})
			},
			//表单初始化
			initDeviceRuleForm(number) {
				let form = {
					name: '',
					ruleNumber: number,
					status: 1,
					remark: '',
					type: 1,
					weekRules: {
						sun: {
							isFullDay: false,
							intervals: [{
								periods: [
									"00:00",
									"23:59"
								],
								type: 10
							}]
						},
						mon: {
							isFullDay: false,
							intervals: [{
								periods: [
									"00:00",
									"23:59"
								],
								type: 10
							}]
						},
						tue: {
							isFullDay: false,
							intervals: [{
								periods: [
									"00:00",
									"23:59"
								],
								type: 10
							}]
						},
						wed: {
							isFullDay: false,
							intervals: [{
								periods: [
									"00:00",
									"23:59"
								],
								type: 10
							}]
						},
						thu: {
							isFullDay: false,
							intervals: [{
								periods: [
									"00:00",
									"23:59"
								],
								type: 10
							}]
						},
						fri: {
							isFullDay: false,
							intervals: [{
								periods: [
									"00:00",
									"23:59"
								],
								type: 10
							}]
						},
						sat: {
							isFullDay: false,
							intervals: [{
								periods: [
									"00:00",
									"23:59"
								],
								type: 10
							}]
						}
					}
				};
				this.deviceRuleForm = Object.assign({}, form)
			},
      //查询未绑定设备
      async getNotBindDeviceList(ruleId) {
        let {
          code,
          data
        } = await DeviceRuleApi.notBindDeviceRegulationList(ruleId);
        if (code == 200) {
          this.deviceData = data.map(device => {
            return {
              key: device.id,
              label: device.name + device.sn,
              name: device.name,
              sn: device.sn,
              disabled: device.status !== 1
            }
          })
          console.log(this.deviceData)
        }
      },
      //查询已绑定设备
      async getBindDeviceList(ruleId) {
        let {
          code,
          data
        } = await DeviceRuleApi.bindDeviceRegulationList(ruleId);
        if (code == 200) {
          this.deviceList = data;
        }
      },
      // 拷贝规则
      copeRule(day){
        this.copeRuleDay = day;
        this.checkAll = false;
        this.checkedWeeks = [];
        this.isIndeterminate = false;
        this.copeDialogVisible = true;
      },
      submitCopeRule(){
        let rule = this.deviceRuleForm.weekRules[this.copeRuleDay];
        if(this.checkedWeeks.length > 0){
          this.checkedWeeks.forEach(week => {
            if(week != this.copeRuleDay){
              this.deviceRuleForm.weekRules[week] = rule
            }
          });
          this.$message.success("复制成功");
          this.copeDialogVisible = false;
        }else{
          this.$message.warning("请选择要复制的星期");
        }
      },
      handleCheckAllChange(val) {
        this.checkedWeeks = val ? this.weeks.map(week => week.value) : [];
        this.isIndeterminate = false;
      },
      handleCheckedWeeksChange(value) {
        let checkedCount = value.length;
        this.checkAll = checkedCount === this.weeks.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.weeks.length;
      }
		}
	}
</script>

<style>
.device-binding-transfer{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.device-binding-transfer .el-transfer__buttons{
  width: 10rem!important;
  padding: 0 5px;
  text-align: center;
}
.device-binding-transfer .el-transfer-panel{
  width: 50%!important;
}
.device-binding-transfer .online::after {
  margin-left: 10px;
  position: absolute;
  content: "";
  top: 50%;
  transform: translateY(-50%);
  left: 24px;
  width: 8px;
  height: 8px;
  background: #1ab137;
  border-radius: 50%;
}

.device-binding-transfer .offline::after {
  margin-left: 10px;
  position: absolute;
  content: "";
  top: 50%;
  transform: translateY(-50%);
  left: 24px;
  width: 8px;
  height: 8px;
  background: #ff0000;
  border-radius: 50%;
}
.device-binding-transfer .option_label{
  margin-left: 11px;
}
.el-checkbox__input.is-disabled + span.el-checkbox__label{
  color: #C0C4CC!important;
}
</style>